import { render, staticRenderFns } from "./TrangXemDanhMucHeThong.vue?vue&type=template&id=128e3612&"
import script from "./TrangXemDanhMucHeThong.vue?vue&type=script&lang=js&"
export * from "./TrangXemDanhMucHeThong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports